import React from 'react';
import { NavLink } from 'react-router-dom';
import { ListItem, ListItemIcon, makeStyles } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';

const useStyles = makeStyles(() => ({
  navListItem: {
    color: 'black !important',
    fontWeight: 'bold',
    height: '56px',
  },
  listItemIcon: { color: 'black !important', fontWeight: 'bold' },
}));

interface NavItemProps {
  name: string;
  link: string;
  icon: IconDefinition;
  index: number;
  selectedIndex: number;
}
const NavItem: React.FC<NavItemProps> = ({ name, link, icon, index, selectedIndex }: NavItemProps) => {
  const styles = useStyles();
  return (
    <ListItem className={styles.navListItem} button component={NavLink} to={link} selected={selectedIndex === index}>
      <ListItemIcon>
        <FontAwesomeIcon className={styles.listItemIcon} icon={icon} size="lg" fixedWidth />
      </ListItemIcon>
      {name}
    </ListItem>
  );
};

export default NavItem;
